// Product/thumbnail images are stored as UploadThing file keys (alphanumeric
// tokens like `7b602XnIvE4b…`), not fully-qualified URLs. The legacy app
// proxied them through its own /api/image-proxy route; we build the public
// CDN URL directly. If the value is already a URL (HTTP[S]) it's used as-is.
//
// Lives in the shared package so the products web entity, the itineraries web
// widgets, and the itineraries API ranking pipeline all read one copy. Previously
// duplicated as `parseUrl` in apps/itineraries/api/src/agent-panel-context/ranking.ts
// and `resolveThumbnailUrl` in apps/products/web/src/entities/product/lib/thumbnail-url.ts.

const UTFS_PREFIX = 'https://utfs.io/f/';

export const resolveThumbnailUrl = (raw: string | null): string | null => {
  if (!raw) return null;
  try {
    // The URL constructor throws on bare keys; happy path is the full URL.
    new URL(raw);
    return raw;
  } catch {
    return `${UTFS_PREFIX}${raw}`;
  }
};
